import React, { useState } from 'react';
import '../App.css';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TableSortLabel,
  Box
} from '@material-ui/core';
import { useRecoilState } from 'recoil';
//import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
//import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import {
  mainBlueColor,
  constructionSortValue,
  constructionSortColumn
} from '../GlobalState';
import { useHistory } from 'react-router-dom';
import { currencyStyle } from '../utils/common';

type GraphStatus = {
  id: number;
  name: string;
  assignee_user: string;
  start_date: string;
  end_date: string;
  planned_sales: number;
  planned_cost: number;
  planned_gross_profit: number;
  planned_gross_profit_rate: number;
  actual_sales: number;
  actual_cost: number;
  actual_gross_profit: number;
  actual_gross_profit_rate: number;
};

type GraphStatuses = {
  currency: number;
  graphStatus: GraphStatus[];
};

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

function createData(
  id: number,
  name: string,
  assignee_user: string | number,
  start_date: string | number,
  end_date: string | number,
  planned_sales: number,
  planned_cost: number,
  planned_gross_profit: number,
  planned_gross_profit_rate: string | number,
  actual_sales: number,
  actual_cost: number,
  actual_gross_profit: number,
  actual_gross_profit_rate: string | number
) {
  return {
    id,
    name,
    assignee_user,
    start_date,
    end_date,
    planned_sales,
    planned_cost,
    planned_gross_profit,
    planned_gross_profit_rate,
    actual_sales,
    actual_cost,
    actual_gross_profit,
    actual_gross_profit_rate
  };
}

const ConstructionSummaryTable: React.FC<GraphStatuses> = graphStatuses => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const history = useHistory();
  const [sortOrder, setSortOrder] = useRecoilState(constructionSortValue);
  const [actualgrossprofitSort, setActualgrossprofitSort] = useState('');
  const [actualCostSort, setActualCostSort] = useState('');
  const [actualgrossprofitRateSort, setActualgrossprofitRateSort] =
    useState('');
  const [actualSaleSort, setActualSaleSort] = useState('');
  const [planedgrossprofitRateSort, setPlanedgrossprofitRateSort] =
    useState('');
  const [planedgrossprofitSort, setPlanedgrossprofitSort] = useState('');
  const [planedCostSort, setPlanedcostSort] = useState('');
  const [planedSaleSort, setPlanedSaleSort] = useState('');
  const [enddateSort, setEnddateSort] = useState('');
  const [startdateSort, setStartdateSort] = useState('');
  const [sortColumn, setSortColumn] = useRecoilState(constructionSortColumn);
  const [order, setOrder] = useState(false);
  const [orderTwo, setOrderTwo] = useState(false);
  const [orderThree, setOrderThree] = useState(false);
  const [orderFour, setOrderFour] = useState(false);
  const [orderFive, setOrderFive] = useState(false);
  const [orderSix, setOrderSix] = useState(false);
  const [orderSeven, setOrderSeven] = useState(false);
  const [orderEight, setOrderEight] = useState(false);
  const [orderNine, setOrderNine] = useState(false);
  const [orderTen, setOrderTen] = useState(false);

  const rows = graphStatuses.graphStatus.map((output, index) => {
    return createData(
      output.id,
      output.name,
      output.assignee_user,
      output.start_date,
      output.end_date,
      output.planned_sales,
      output.planned_cost,
      output.planned_gross_profit,
      output.planned_gross_profit_rate,
      output.actual_sales,
      output.actual_cost,
      output.actual_gross_profit,
      output.actual_gross_profit_rate
    );
  });

  const useStyles = makeStyles({
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: mainColor,
      color: '#FFFFFF',
      fontSize: 16
    },
    table1: {
      color: '#000000',
      fontSize: 16
    }
  });

  function createSortHandler(name: any) {
    if (name == 'actual_gross_profit') {
      setSortOrder('ascending');
      setSortColumn(name);
      setActualgrossprofitSort('ascending');
      setActualgrossprofitRateSort('');
      setActualCostSort('');
      setActualSaleSort('');
      setPlanedgrossprofitRateSort('');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
    } else if (name == 'actual_gross_profit_rate') {
      setSortOrder('ascending');
      setSortColumn(name);
      setActualgrossprofitRateSort('ascending');
      setActualCostSort('');
      setActualSaleSort('');
      setPlanedgrossprofitRateSort('');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setActualgrossprofitSort('');
    } else if (name == 'actual_cost') {
      setSortOrder('ascending');
      setSortColumn(name);
      setActualCostSort('ascending');
      setActualSaleSort('');
      setPlanedgrossprofitRateSort('');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'actual_sales') {
      setSortOrder('ascending');
      setSortColumn(name);
      setActualSaleSort('ascending');
      setPlanedgrossprofitRateSort('');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'planned_gross_profit_rate') {
      setSortOrder('ascending');
      setSortColumn(name);
      setPlanedgrossprofitRateSort('ascending');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'planned_gross_profit') {
      setSortOrder('ascending');
      setSortColumn(name);
      setPlanedgrossprofitSort('ascending');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'planned_cost') {
      setSortOrder('ascending');
      setSortColumn(name);
      setPlanedcostSort('ascending');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setPlanedgrossprofitSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'planned_sales') {
      setSortOrder('ascending');
      setSortColumn(name);
      setPlanedSaleSort('ascending');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedcostSort('');
      setPlanedgrossprofitSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'end_date') {
      setSortOrder('ascending');
      setSortColumn(name);
      setEnddateSort('ascending');
      setStartdateSort('');
      setPlanedcostSort('');
      setPlanedSaleSort('');
      setPlanedgrossprofitSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'start_date') {
      setSortOrder('ascending');
      setSortColumn(name);
      setStartdateSort('ascending');
      setEnddateSort('');
      setPlanedcostSort('');
      setPlanedSaleSort('');
      setPlanedgrossprofitSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    }
  }
  function createSortUpHandler(name: any) {
    if (name == 'actual_gross_profit') {
      setSortOrder('descending');
      setSortColumn(name);
      setActualgrossprofitSort('descending');
      setActualgrossprofitRateSort('');
      setActualCostSort('');
      setActualSaleSort('');
      setPlanedgrossprofitRateSort('');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
    } else if (name == 'actual_gross_profit_rate') {
      setSortOrder('descending');
      setSortColumn(name);
      setActualgrossprofitRateSort('descending');
      setActualCostSort('');
      setActualSaleSort('');
      setPlanedgrossprofitRateSort('');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setActualgrossprofitSort('');
    } else if (name == 'actual_cost') {
      setSortOrder('descending');
      setSortColumn(name);
      setActualCostSort('descending');
      setActualSaleSort('');
      setPlanedgrossprofitRateSort('');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'actual_sales') {
      setSortOrder('descending');
      setSortColumn(name);
      setActualSaleSort('descending');
      setPlanedgrossprofitRateSort('');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'planned_gross_profit_rate') {
      setSortOrder('descending');
      setSortColumn(name);
      setPlanedgrossprofitRateSort('descending');
      setPlanedgrossprofitSort('');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'planned_gross_profit') {
      setSortOrder('descending');
      setSortColumn(name);
      setPlanedgrossprofitSort('descending');
      setPlanedcostSort('');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'planned_cost') {
      setSortOrder('descending');
      setSortColumn(name);
      setPlanedcostSort('descending');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedSaleSort('');
      setPlanedgrossprofitSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'planned_sales') {
      setSortOrder('descending');
      setSortColumn(name);
      setPlanedSaleSort('descending');
      setEnddateSort('');
      setStartdateSort('');
      setPlanedcostSort('');
      setPlanedgrossprofitSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'end_date') {
      setSortOrder('descending');
      setSortColumn(name);
      setEnddateSort('descending');
      setStartdateSort('');
      setPlanedcostSort('');
      setPlanedSaleSort('');
      setPlanedgrossprofitSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    } else if (name == 'start_date') {
      setSortOrder('descending');
      setSortColumn(name);
      setStartdateSort('descending');
      setEnddateSort('');
      setPlanedcostSort('');
      setPlanedSaleSort('');
      setPlanedgrossprofitSort('');
      setPlanedgrossprofitRateSort('');
      setActualSaleSort('');
      setActualCostSort('');
      setActualgrossprofitRateSort('');
      setActualgrossprofitSort('');
    }
  }

  const classes = useStyles();

  return (
    <>
      <div className='responsive-container-main-table'>
        <TableContainer component={Paper}>
          <Table className={classes.main} aria-label='customized table'>
            <TableHead>
              <TableRow>
                <StyledTableCell className={classes.table} align='center'>
                  工事名
                </StyledTableCell>
                <StyledTableCell
                  className={classes.table}
                  style={{ minWidth: 70 }}
                  align='center'
                >
                  担当者名
                </StyledTableCell>
                {/* onClick={() => createSortHandler("start_date")} */}
                {startdateSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrder(true);
                      createSortHandler('start_date');
                      setOrderTwo(false);
                      setOrderThree(false);
                      setOrderFour(false);
                      setOrderFive(false);
                      setOrderSix(false);
                      setOrderSeven(false);
                      setOrderEight(false);
                      setOrderNine(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {order == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        着工日
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        着工日
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrder(true)}
                    className={classes.table}
                    align='center'
                  >
                    {order == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        着工日
                        {startdateSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortHandler('start_date')}
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortUpHandler('start_date')}
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        着工日
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {enddateSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderTwo(true);
                      createSortHandler('end_date');
                      setOrder(false);
                      setOrderThree(false);
                      setOrderFour(false);
                      setOrderFive(false);
                      setOrderSix(false);
                      setOrderSeven(false);
                      setOrderEight(false);
                      setOrderNine(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {orderTwo == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        竣工日
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        竣工日
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderTwo(true)}
                    className={classes.table}
                    align='center'
                  >
                    {orderTwo == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        竣工日
                        {enddateSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortHandler('end_date')}
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortUpHandler('end_date')}
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        竣工日
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {/* <StyledTableCell className={classes.table} align="center">
                  竣工日
                </StyledTableCell> */}
                {planedSaleSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderThree(true);
                      createSortHandler('planned_sales');
                      setOrder(false);
                      setOrderTwo(false);
                      setOrderFour(false);
                      setOrderFive(false);
                      setOrderSix(false);
                      setOrderSeven(false);
                      setOrderEight(false);
                      setOrderNine(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {orderThree == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        計画売上
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        計画売上
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderThree(true)}
                    className={classes.table}
                    align='center'
                  >
                    {orderThree == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        計画売上
                        {planedSaleSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortHandler('planned_sales')}
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortUpHandler('planned_sales')}
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        計画売上
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {planedCostSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderFour(true);
                      createSortHandler('planned_cost');
                      setOrder(false);
                      setOrderTwo(false);
                      setOrderThree(false);
                      setOrderFive(false);
                      setOrderSix(false);
                      setOrderSeven(false);
                      setOrderEight(false);
                      setOrderNine(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {orderFour == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        計画原価
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        計画原価
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderFour(true)}
                    className={classes.table}
                    align='center'
                  >
                    {orderFour == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        計画原価
                        {planedCostSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortHandler('planned_cost')}
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortUpHandler('planned_cost')}
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        計画原価
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {planedgrossprofitSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderFive(true);
                      createSortHandler('planned_gross_profit');
                      setOrder(false);
                      setOrderTwo(false);
                      setOrderFour(false);
                      setOrderThree(false);
                      setOrderSix(false);
                      setOrderSeven(false);
                      setOrderEight(false);
                      setOrderNine(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {orderFive == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        計画粗利
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        計画粗利
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderFive(true)}
                    className={classes.table}
                    align='center'
                  >
                    {orderFive == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        計画粗利
                        {planedgrossprofitSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() =>
                              createSortHandler('planned_gross_profit')
                            }
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() =>
                              createSortUpHandler('planned_gross_profit')
                            }
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        計画粗利
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {planedgrossprofitRateSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderSix(true);
                      createSortHandler('planned_gross_profit_rate');
                      setOrder(false);
                      setOrderTwo(false);
                      setOrderFour(false);
                      setOrderFive(false);
                      setOrderThree(false);
                      setOrderSeven(false);
                      setOrderEight(false);
                      setOrderNine(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {orderSix == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        計画粗利率
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        計画粗利率
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderSix(true)}
                    className={classes.table}
                    align='center'
                  >
                    {orderSix == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        計画粗利率
                        {planedgrossprofitRateSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() =>
                              createSortHandler('planned_gross_profit_rate')
                            }
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() =>
                              createSortUpHandler('planned_gross_profit_rate')
                            }
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        計画粗利率
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {actualSaleSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderSeven(true);
                      createSortHandler('actual_sales');
                      setOrder(false);
                      setOrderTwo(false);
                      setOrderFour(false);
                      setOrderFive(false);
                      setOrderSix(false);
                      setOrderThree(false);
                      setOrderEight(false);
                      setOrderNine(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {orderSeven == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        売上実績
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        売上実績
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderSeven(true)}
                    className={classes.table}
                    align='center'
                  >
                    {orderSeven == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        売上実績
                        {actualSaleSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortHandler('actual_sales')}
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortUpHandler('actual_sales')}
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        売上実績
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {actualCostSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderEight(true);
                      createSortHandler('actual_cost');
                      setOrder(false);
                      setOrderTwo(false);
                      setOrderFour(false);
                      setOrderFive(false);
                      setOrderSix(false);
                      setOrderSeven(false);
                      setOrderThree(false);
                      setOrderNine(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {orderEight == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        原価実績
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        原価実績
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderEight(true)}
                    className={classes.table}
                    align='center'
                  >
                    {orderEight == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        原価実績
                        {actualCostSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortHandler('actual_cost')}
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() => createSortUpHandler('actual_cost')}
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        原価実績
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {actualgrossprofitSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderNine(true);
                      createSortHandler('actual_gross_profit');
                      setOrder(false);
                      setOrderTwo(false);
                      setOrderFour(false);
                      setOrderFive(false);
                      setOrderSix(false);
                      setOrderSeven(false);
                      setOrderEight(false);
                      setOrderThree(false);
                      setOrderTen(false);
                    }}
                    className={classes.table}
                    align='center'
                  >
                    {orderNine == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        粗利実績
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        粗利実績
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderNine(true)}
                    className={classes.table}
                    align='center'
                  >
                    {orderNine == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        粗利実績
                        {actualgrossprofitSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() =>
                              createSortHandler('actual_gross_profit')
                            }
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() =>
                              createSortUpHandler('actual_gross_profit')
                            }
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        粗利実績
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
                {/* <StyledTableCell className={classes.table} style={{ minWidth: 70 }} align="center">
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    粗利実績<div style={{ display: "flex", flexDirection: "column", gap: "15px" }}><span onClick={() => createSortHandler("actual_gross_profit")} className="down__arrow" /><span onClick={() => createSortUpHandler("actual_gross_profit")} className="up__arrow" /></div>
                  </div>
                </StyledTableCell> */}
                {actualgrossprofitRateSort == '' ? (
                  <StyledTableCell
                    onClick={() => {
                      setOrderTen(true);
                      createSortHandler('actual_gross_profit_rate');
                      setOrder(false);
                      setOrderTwo(false);
                      setOrderFour(false);
                      setOrderFive(false);
                      setOrderSix(false);
                      setOrderSeven(false);
                      setOrderEight(false);
                      setOrderNine(false);
                      setOrderThree(false);
                    }}
                    className={classes.table}
                    style={{ minWidth: 70 }}
                    align='center'
                  >
                    {orderTen == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        粗利率実績
                        <span className='down__arrow' />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        粗利率実績
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell
                    onClick={() => setOrderTen(true)}
                    className={classes.table}
                    style={{ minWidth: 70 }}
                    align='center'
                  >
                    {orderTen == true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        粗利率実績
                        {actualgrossprofitRateSort == 'descending' ? (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() =>
                              createSortHandler('actual_gross_profit_rate')
                            }
                          >
                            <span className='down__arrow' />
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            onClick={() =>
                              createSortUpHandler('actual_gross_profit_rate')
                            }
                          >
                            <span className='up__arrow' />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        粗利率実績
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                          }}
                        >
                          <span className='up__arrow' />
                          <span className='down__arrow' />
                        </div>
                      </div>
                    )}
                  </StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                //console.log("table", row)
                <StyledTableRow className='click_table_row' key={row.id}>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='center'
                  >
                    {row.name}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='center'
                  >
                    {row.assignee_user}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='center'
                  >
                    {row.start_date}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='center'
                  >
                    {row.end_date}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='right'
                  >
                    {currencyStyle(row.planned_sales, graphStatuses.currency)}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='right'
                  >
                    {currencyStyle(row.planned_cost, graphStatuses.currency)}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='right'
                  >
                    {currencyStyle(
                      row.planned_gross_profit,
                      graphStatuses.currency
                    )}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='right'
                  >
                    {row.planned_gross_profit_rate} %
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='right'
                  >
                    {currencyStyle(row.actual_sales, graphStatuses.currency)}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='right'
                  >
                    {currencyStyle(row.actual_cost, graphStatuses.currency)}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='right'
                  >
                    {currencyStyle(
                      row.actual_gross_profit,
                      graphStatuses.currency
                    )}
                  </StyledTableCell>
                  <StyledTableCell
                    onClick={() => {
                      history.push(`/constructions/${row.id}/edit`, {
                        state: row.id
                      });
                    }}
                    className={classes.table1}
                    align='right'
                  >
                    {row.actual_gross_profit_rate} %
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div style={{ backgroundColor: '#F5F5F5', height: 80 }} />
    </>
  );
};
export default ConstructionSummaryTable;
